import React from "react"
import { Div, Text } from "atomize"
import { theme } from "../settings/config"
import RadioBox from "../atoms/RadioBox"
import HelpTip from "../help/HelpTip"
import { COURT_PAID_BY_COACH, COURT_PAID_BY_PLAYERS } from "../utils/billing.utils"

// Di chi è il conto del campo, di solito, nelle lezioni private di questo
// circolo. Sono due modi di fare lo stesso lavoro allo stesso prezzo: o il
// campo lo paghi tu e l'allievo ti dà tutto, o lo pagano loro al circolo e
// tu chiedi meno. Cambia solo da che parte passano i soldi del campo, ma il
// riepilogo deve saperlo, altrimenti scala un costo che non hai avuto.
//
// È la regola del circolo, non una condanna: ogni lezione può fare
// diversamente, e la scelta si cambia dal modulo della lezione.
const OPTIONS = [
	{
		value: COURT_PAID_BY_COACH,
		title: "Lo pago io",
		detail: "L'allievo paga il prezzo pieno di listino e il campo si scala dal riepilogo.",
	},
	{
		value: COURT_PAID_BY_PLAYERS,
		title: "Lo pagano gli allievi",
		detail:
			"Dal prezzo di listino viene tolta la quota di campo di ognuno, e dal riepilogo non si scala niente.",
	},
]

function CourtPaidByEditor({ courtPaidBy, onChange }) {
	return (
		<Div m={{ b: "1.5rem" }}>
			<HelpTip tip="chiPagaCampo" inline m={{ b: "0.5rem" }}>
				<Text textSize="body" textWeight="bold" textColor={theme.colors.text_light}>
					Di solito il campo
				</Text>
			</HelpTip>

			{OPTIONS.map(option => (
				<Div key={option.value} m={{ b: "0.5rem" }}>
					<RadioBox
						text={option.title}
						checked={courtPaidBy === option.value}
						handleChange={() => onChange(option.value)}
					/>
					<Text
						textSize="caption"
						textColor={theme.colors.text_light}
						m={{ l: "2.5rem" }}>
						{option.detail}
					</Text>
				</Div>
			))}

			<Text textSize="caption" textColor={theme.colors.text_light} m={{ t: "0.75rem" }}>
				In tutti e due i casi la tariffa qui sotto è quanto costa il campo: se lo pagano
				loro serve a sapere quanto togliere dal prezzo.
			</Text>
		</Div>
	)
}

export default CourtPaidByEditor
